import {SET_STEPS_SELECTION} from 'constants/action-types.js';
import {SET_SELECTED_STEPS} from 'constants/action-types.js';
import {SET_STEP_NUMBER_DRAGGING_FROM} from 'constants/action-types.js';
import {SET_STEP_NUMBER_DRAGGED_TO} from 'constants/action-types.js';
import {SET_SINGLE_STEP_TO_DRAG} from 'constants/action-types.js';
import {SET_SHOW_STEP_OPTIONS} from 'constants/action-types.js';
import {SET_MASTER_STEP_TOGGLES} from 'constants/action-types.js';
import {SET_CIRKLON_MODE} from 'constants/action-types.js';
import {NEW_STEP_GROUP} from 'constants/action-types.js';

let initialState = {
    stepGroups: [],
    stepsSelection: undefined,
    selectedSteps: undefined,
    stepNumberDraggingFrom: undefined,
    stepNumberDraggedTo: undefined,
    singleStepToDrag: undefined,
    showStepOptions: undefined,
    masterStepToggles: Array(16).fill(true),
};

const stepsReducer= (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case NEW_STEP_GROUP:
        return {
            ... state,
            stepGroups: [... state.stepGroups, action.payload]
        };
    case SET_STEPS_SELECTION:
        if (action.payload.fromStep === undefined) {
            return { ... state, stepsSelection: undefined};
        }
        return { ... state, stepsSelection: action.payload};
    case SET_SELECTED_STEPS:
        if (action.payload.trackNumber === undefined) {
            return { ... state, selectedSteps: undefined};
        }
        return { ... state, selectedSteps: action.payload};
    case SET_STEP_NUMBER_DRAGGING_FROM:
        return { ... state, stepNumberDraggingFrom: action.payload};
    case SET_MASTER_STEP_TOGGLES:
        return { ... state, masterStepToggles: action.payload};
    case SET_SINGLE_STEP_TO_DRAG:
        return { ... state, singleStepToDrag: action.payload};
    case SET_STEP_NUMBER_DRAGGED_TO:
        return { ... state, stepNumberDraggedTo: action.payload};
    case SET_SHOW_STEP_OPTIONS:
        if (action.payload.option === undefined) {
            return {... state, showStepOptions: undefined};
        }
        return { ... state,
                 showStepOptions: {
                     option: action.payload.option,
                     effect: action.payload.effect,
                 }
               };
    default:
        return state;
    }
};

export default stepsReducer;
